import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function addDepartmentColleagues(colleagues) {
  return dispatchCommand('AddDepartmentColleagues', colleagues);
}
